import { Component, OnInit, ViewChild } from '@angular/core';
import { ProveedoresService } from '../../../services/proveedores.service';
import { CuentasPorCobrarService } from '../../../services/cuentas-por-cobrar.service';
import { Router } from '@angular/router';
import { AutenticacionService, ModulosARK, TipoPermiso } from '../../../services/autenticacion.service';
import { ModalEliminarContratoComponent } from './modal-eliminar-contrato/modal-eliminar-contrato.component';
import { ModalVerContratoComponent } from './modal-ver-contrato/modal-ver-contrato.component';

@Component({
  selector: 'app-listado-contratos',
  templateUrl: './listado-contratos.component.html',
  styleUrls: ['./listado-contratos.component.scss']
})
export class ListadoContratosComponent implements OnInit {
    @ViewChild('modalEliminarContrato') private modalEliminarContrato: ModalEliminarContratoComponent;
    @ViewChild(ModalVerContratoComponent) private modalVerContrato: ModalVerContratoComponent;

    public obra: any = {};
    public obras: any [] = [];

    public proveedor: any = {};
    public proveedores: any [] = [];

    public loading: boolean = true;
    public loading_obras: boolean = false;
    public loading_proveedores: boolean = false;

    //helpers
    public contratos: any [] = [];
    public search: string = '';
    private searchTimeout: any;
    errors:any = {};
    public permitirEliminarContratos: boolean = false;

    //paginacion
    paginate:any = {};
    page: number = 1;
    pageSize: number = 10;
    pageAll: number = 100;
    lastPage: any = 1;

    constructor(
        private router: Router,
        private authService: AutenticacionService,
        private proveedoresService: ProveedoresService,
        private cuentasPorCobrarService: CuentasPorCobrarService) {
    }

    ngOnInit() {
        this.loadObras();
        this.permitirEliminarContratos = this.authService.tienenPermisos(ModulosARK.EliminarContratos, TipoPermiso.Escritura);
    }

    hasPermission(permissionId) {
        return this.authService.hasPermission(permissionId);
    }

    loadObras(){
        this.loading_obras = true;
        this.cuentasPorCobrarService.getObras()
        .subscribe((response) => {
            this.obras = response.json().content;
            this.loadProveedores();
            this.loading_obras = false;
        },error=>{
            alert("ERROR: "+JSON.stringify(error));
            this.loading_obras = false;
        });
    }

    loadProveedores(){
        this.loading_proveedores = true;
        this.cuentasPorCobrarService.getProveedores()
        .subscribe(response => {
            let content = response.json().content;
            this.proveedores = content.proveedores;
            this.loading_proveedores = false;
            this.loadContratos();
        },error=>{
            alert("ERROR: "+JSON.stringify(error));
            this.loading_proveedores = false;
        });
    }

    // MAIN SECTIONS FUNCTIONS     
    writePermission() {
        return this.proveedoresService.writePermission();
    }

    canExport() {
        return this.proveedoresService.canExport();
    }

    public loadContratos(){
        this.loading = true;
        var id_obra = null;
        if(this.obra && this.obra.idObras && this.obra.idObras!=0){
            id_obra = this.obra.idObras;
        }
        var id_proveedor = null;
        if(this.proveedor && this.proveedor.idProveedores && this.proveedor.idProveedores!=0){
            id_proveedor = this.proveedor.idProveedores;
        }
        this.cuentasPorCobrarService.listarContratos(this.page, id_obra, id_proveedor, this.search)
        .subscribe(
            response=>{
                let content = response.json().content.data;
                this.contratos = content;

                this.paginate = response.json().content;
                this.page = this.paginate.current_page;
                this.pageSize = this.paginate.per_page;
                this.pageAll = this.paginate.total;
                this.loading = false;
            },
            error=>{
                this.loading = false;
                alert("ERROR:: "+JSON.stringify(error));
            }
        );
    }

    seleccionarContrato(contrato){
        var id_contrato = contrato.id_contrato;
        if(contrato.estatus_creacion.toLowerCase()!="borrador"){
            alert("Este contrato ya esta en estatus final, solo puede ser modificado mediante convenios del administrador");
        }else{
            this.router.navigate(['contrato',{id: id_contrato}]);
        }
    }

    pageChanged($event){
        this.page = $event;
        this.loadContratos();
    }

    changeObraFilter($event){
        this.obra = $event;
        this.loadContratos();
    }

    changeProveedorFilter($event){
        this.proveedor = $event;
        this.loadContratos();
    }

    //Buscador general: reinicia a la primera pagina y consulta
    buscar(){
        this.page = 1;
        this.loadContratos();
    }

    //Buscador en vivo: consulta mientras se escribe, con un pequeno retraso (debounce)
    onSearch(value){
        this.search = value;
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.page = 1;
            this.loadContratos();
        }, 350);
    }

    limpiarBusqueda(){
        this.search = '';
        this.page = 1;
        this.loadContratos();
    }

    mostrarConvenios(contrato){
        this.router.navigate(['/convenios/'+contrato.id_contrato])
    }

    public mostrarModalEliminarContrato(contrato){
        this.modalEliminarContrato.openModal(contrato);
    }
    
    public previsualizar(contrato){
        var id_contrato = contrato.id_contrato;
        console.log(id_contrato);
        this.modalVerContrato.openModal(id_contrato);
    }

}


// WEBPACK FOOTER //
// ./src/app/components/contratos/listado/listado-contratos.component.ts